// this is a copy of the ../DisplayTracker file, this should be the new version we use going forward
// this version DOES NOT inject an mraid stub

/* @flow */
/* @jsx h */
import { h, Component } from 'preact';
import { injectTags } from '../../js/inject-tags';
import { isOMIDSDKActivated } from '../../js/omid/omid';
let renderedIds: string[] = [];
const injectionTimeout = 250;

export type DisplayTrackersProps = DisplayTrackersType & {
  id: string;
};

export class DisplayTrackers extends Component<DisplayTrackersProps> {
  id: string;

  constructor(props: DisplayTrackersProps) {
    super(props);

    this.id = props.id || 'displayTrackers';
  }

  componentDidMount() {
    if (window.isOgyPreview) {
      return;
    }
    if (renderedIds.indexOf(this.id) === -1) {
      renderedIds.push(this.id);

      let trackersCode = this.props.trackers;
      // Inject OMID trackers when tracking agnosticity is activated and OMID is deactivated
      const useOmidTracking =
        this.props.omidTrackingEnabled && isOMIDSDKActivated();
      if (this.props.allowAgnosticTracking && !useOmidTracking) {
        trackersCode += this.props.omidTrackers;
      }

      const defaultContainer = `#${this.id}`;

      // this will overrive the document.write
      setTimeout(() => {
        injectTags(
          trackersCode,
          this.props.htmlContainerSelector || defaultContainer,
          this.props.scriptContainerSelector || defaultContainer,
          defaultContainer,
          {
            overloadDocumentWrite: this.props.overloadDocumentWrite,
            enableSentryLog: this.props.enableSentryLog,
            allowInjectIntoBody: false
          }
        );
      }, injectionTimeout);
    }
  }

  shouldComponentUpdate() {
    return false;
  }

  render() {
    const style = {
      display: 'none'
    };
    return <div id={this.id} style={style} />;
  }
}

export function reset() {
  renderedIds = [];
}
